var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.8867C6.40661 10.8867 5.11328 9.59333 5.11328 8C5.11328 6.40667 6.40661 5.11333 7.99995 5.11333C9.59328 5.11333 10.8866 6.40667 10.8866 8C10.8866 9.59333 9.59328 10.8867 7.99995 10.8867ZM7.99995 6.11333C6.95995 6.11333 6.11328 6.96 6.11328 8C6.11328 9.04 6.95995 9.88667 7.99995 9.88667C9.03995 9.88667 9.88661 9.04 9.88661 8C9.88661 6.96 9.03995 6.11333 7.99995 6.11333Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 14.0133C5.49306 14.0133 3.12639 12.5467 1.49973 10C0.79306 8.9 0.79306 7.10667 1.49973 6C3.13306 3.45333 5.49973 1.98667 7.99973 1.98667C10.4997 1.98667 12.8664 3.45333 14.4931 6C15.1997 7.1 15.1997 8.89333 14.4931 10C12.8664 12.5467 10.4997 14.0133 7.99973 14.0133ZM7.99973 2.98667C5.84639 2.98667 3.78639 4.28 2.34639 6.54C1.84639 7.32 1.84639 8.68 2.34639 9.46C3.78639 11.72 5.84639 13.0133 7.99973 13.0133C10.1531 13.0133 12.2131 11.72 13.6531 9.46C14.1531 8.68 14.1531 7.32 13.6531 6.54C12.2131 4.28 10.1531 2.98667 7.99973 2.98667Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.2469d2e74b9c41953671dd623854872a.svg";
export { ForwardRef as ReactComponent };